<template>
  <div>
    <section id="content01">
      <Header/>
      <section id="content02" class="inner box_result">
        <div class="box_ttl">
          <h2>結果発表</h2>
          <p class="txt">あなたにおすすめのモデルハウスは…</p>
        </div>
        <div class="box_result_no1">
          <p class="num"><img src="../assets/img/cap_gold.png" width="" height="" alt="No.1">No.1</p>
          <figure><img :src="housemaker[0].img"></figure>
          <p class="name">{{housemaker[0].name}}</p>
          <p class="company">{{housemaker[0].title}}</p>
          <p class="btn_lnk_result"><a :href="housemaker[0].href" target="_blank">モデルハウスの詳細をみる</a></p>
        </div>
        <ul class="lst_result">
          <li v-for="n in 4" v-bind:key="n">
            <p v-if="n === 1" :class="'num no'+(n+1)"><img src="../assets/img/cap_silver.png" width="" height="" alt="">No.{{n+1}}</p>
            <p v-else-if="n === 2" :class="'num no'+(n+1)"><img src="../assets/img/cap_brons.png" width="" height="" alt="">No.{{n+1}}</p>
            <p v-else class="num">No.{{n+1}}</p>

            <figure><img :src="housemaker[n].img" width="" height="" alt=""></figure>
            <p class="name">{{housemaker[n].name}}</p>
            <p class="company">{{housemaker[n].title}}</p>
            <p class="btn_lnk_result"><a :href="housemaker[n].href" target="_blank">モデルハウスの詳細をみる</a></p>
          </li>

        </ul>
        <div class="btn_result_back">
          <a href="./">トップへ戻る</a>
        </div>
      </section>

    </section>
    <Footer/>
  </div>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import _ from 'lodash'

export default {
  name: 'Result',
  components: {
    Header,
    Footer
  },
  computed:{
    housemaker:function(){
      const result = this.$store.getters.housemaker
      //return _.sortBy(result,'haspoint')
      return _.orderBy(result, ['haspoint'], ['desc']);
    },
  },
  method:{
    // sort:function(val){

    // }

  }
}
</script>